import { formRules } from "../../../config/validations/formRules";
import {
  maxEmail,
  maxPassword,
  minPassword,
  validations,
} from "../../../config/validations/validations";

export const rules: any = {
  name: () => formRules.name(),
  email: (field?: string) => [
    validations.required.text(field),
    validations.email(field),
    validations.max.text(maxEmail, field),
  ],
  mobileNumber: () => formRules.mobileNumber(),
  password: (field?: any) => [
    validations.required.text(field),
    validations.pattern.password(field),
    validations.min.text(minPassword),
    validations.max.text(maxPassword),
  ],
};
